// Enums
import { redirectToSignInPath } from 'common/utils/authHelpers';

export const authorizeAction = (authenticated, action, redirectUrl) =>
  authenticated ? action() : redirectToSignInPath(redirectUrl);
